cobalt-input-text {
  display: block;
}

cobalt-input-text .icon-box {
  padding: var(--number-spacing-none);
}

cobalt-input-text .input-text-format--aside .input-text-header {
  min-height: 2.25rem;
}